import { AuthType } from "../types.store";

export const account_user = (state: { account: AuthType }) => state.account;